export default __webpack_public_path__ + "static/media/gallery_01.7d2c2985.jpg";